import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { useStatiegeldStats } from "../../store/useStatiegeldStats";
import { tomraCanTypes } from "../../utils/tomraCanTypes";

dayjs.extend(relativeTime);

export const StatiegeldSupergroupTable = () => {
  /** Hooks */
  const { statiegeldStats } = useStatiegeldStats();

  return (
    <div className="relative overflow-x-auto">
      <table className="w-full text-base font-normal font-satoshi text-left rtl:text-right text-dark">
        <thead className="font-medium bg-gray-50">
          <tr>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Supergroup
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Count
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
            >
              Refund
            </th>
          </tr>
        </thead>
        <tbody>
          {statiegeldStats?.supergroupStats?.map((item) => {
            return (
              <tr
                key={item.superGroup}
                className="bg-white hover:bg-gray-100 cursor-pointer transition ease-linear border-b"
              >
                <td className="px-2 sm:px-6 py-1 sm:py-4 break-all sm:whitespace-nowrap text-xs sm:text-base">
                  {tomraCanTypes[item.superGroup]?.label ?? "Unknown"}
                </td>
                <td className="px-2 sm:px-6 py-1 sm:py-4 break-all text-xs sm:text-base">
                  {item?.totalItems}
                </td>
                <td className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4">
                  {new Intl.NumberFormat("nl-NL", {
                    style: "decimal",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  }).format(Number(item?.totalRefund ?? 0) / 1000)} €
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
